import { FormValues } from './Barcode.types';

export const defaultValues: FormValues = {
  barcode: '',
};
